// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"gr-z","breadcrumbForward":"hr-z","breadcrumbBack":"ir-z","selected":"jr-z"};